<template functional>
  <div>
    <format-number
      :value="
        props.row.irrigation_coefficient
          ? props.row.irrigation_coefficient
          : '-'
      "
      :messageLabel="['irrigation.irrigation_coefficient', ':', ' ']"
      :strongMessageLabel="true"
      listClass=""
    />
    <format-number
      :value="props.row.wilting_point ? props.row.wilting_point : '-'"
      :messageLabel="['irrigation.wilting_point', ':', ' ']"
      :strongMessageLabel="true"
      listClass=""
    />
    <format-number
      :value="props.row.saturation_point ? props.row.saturation_point : '-'"
      :messageLabel="['irrigation.saturation_point', ':', ' ']"
      :strongMessageLabel="true"
      listClass=""
    />
  </div>
</template>

<script>
export default {
  name: 'FormattComponent',
};
</script>
